module.exports = __webpack_public_path__ + "img/empty-cart.0f6e0486.png";